import loadable from '@loadable/component';

export const CmsSupportContactFormBlockLoadable = loadable(
  () => import('./CmsSupportContactFormBlock'),
  { resolveComponent: (module) => module.CmsSupportContactFormBlock },
);
